import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { remintFileTokens } from '/imports/api/devtools';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';

/** Dev tool: re-mint every stored file's /nfs capability token to a valid JWT, so NFS_REQUIRE_TOKEN can be
 *  enabled without 404-ing legacy files (those minted before the token-gate change). Idempotent. */
export const DevToolRemintFileTokens = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const run = toastOnError(async () => {
    setLoading(true);
    setResult('');
    try {
      const res = await remintFileTokens.call();
      setResult(JSON.stringify(res, null, 2));
      toast.success(`Re-minted ${res.reminted} token(s) across ${res.docsUpdated} doc(s); ${res.alreadyValid} already valid`);
    }
    finally {
      setLoading(false);
    }
  });
  return (
    <DevToolSection
      title="Re-mint File Tokens"
      description="Scan every collection and re-sign each stored file's <b>/nfs</b> capability token as a valid JWT, so <b>NFS_REQUIRE_TOKEN</b> can be enabled without breaking files uploaded before the auth-gate change. Idempotent — already-valid tokens are left untouched. Very large telemetry collections are skipped (and reported)."
      onRun={() => run()}
      buttonText={loading ? 'Running…' : 'Re-mint tokens'}
      loading={loading}
    >
      {result && <pre>{result}</pre> || null}
    </DevToolSection>
  );
};
